import { createReducer } from '../../helpers/reducer';
import actions from './actions';
import { IPermissionsData, IPermissionsState } from './types';

const initState: IPermissionsState = {
  data: null,
  isLoading: false,
};

function onFetchRequest(state: IPermissionsState) {
  return { ...state, isLoading: true };
}

function onFetchSuccess(state: IPermissionsState, { payload }: { payload: { data: IPermissionsData } }) {
  return { ...state, data: payload.data, isLoading: false };
}

function onFetchError(state: IPermissionsState) {
  return { ...state, isLoading: false };
}

export default createReducer(initState, {
  [actions.FETCH_PERMISSIONS_REQUEST]: onFetchRequest,
  [actions.FETCH_PERMISSIONS_SUCCESS]: onFetchSuccess,
  [actions.FETCH_PERMISSIONS_ERROR]: onFetchError,
});
